import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import UserInformation from './pages/UserInformation';
import UserInformationPassword from './pages/UserInformationPassword';
import ResetPassword from './pages/ResetPassword';
import posthog from 'posthog-js'


export default function App() {

useEffect(() => {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_API_HOST, opt_in_site_apps: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "*"
    }
  })
  posthog.capture('my event', { property: 'value' })
}, [])

  return (
    <BrowserRouter>
      <Routes>
        <Route path='set_user_information' element={<UserInformation />} />
        <Route path='set_user_password' element={<UserInformationPassword />} />
        <Route path='user_reset_password' element={<ResetPassword />} />
      </Routes>
    </BrowserRouter>
  );
}
